import { render, staticRenderFns } from "./order_ph.vue?vue&type=template&id=6d97ff0a&scoped=true"
import script from "./order_ph.vue?vue&type=script&lang=js"
export * from "./order_ph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d97ff0a",
  null
  
)

export default component.exports